export class Payment {
    public PaymentType!: string;
    public Amount!: number;
    public AccountIdentifier!: number;
    public PayerName!: string;
    public ExpiryMonth!: string;
    public ExpiryYear!: string;
    public BillingContact!: number;
    public CVV!: number;
    public BillingAddress = new class {
        public AddressType!: string;
        public Address1!: string;
        public Address2!: string;
        public City!: string;
        public Province!: string;
        public PostalCode!: string;
        public Country!: string;
    }

    
    constructor(){       
        this.PaymentType="CREDITCARD";
        this.BillingAddress.AddressType="HOME";
        this.BillingAddress.Country="CA";
    }
}